import './password.scss';
import React from 'react';
import { Translate, translate, getUrlParameter } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Button, Alert } from 'reactstrap';
import { Redirect, RouteComponentProps, Link } from 'react-router-dom';
import MessageModal from '../../../shared/message/message-modal';
import { IRootState } from 'app/shared/reducers';
import { savePassword, reset } from './password.reducer';
import { getSession } from 'app/shared/reducers/authentication';
import { SUCCESS } from 'app/config/constants';
import { login } from 'app/shared/util/utilities';

export interface IUserPasswordProps extends StateProps, DispatchProps, RouteComponentProps<{ id: any; key: any }> {}

export interface IUserPasswordState {
  password: string;
  visible: boolean;
  color: string;
  message: string;
  redirectLogin: boolean;
  showMessage: boolean;
  isMobile: boolean;
  disableButtonReg: boolean;
}

export class PasswordPage extends React.Component<IUserPasswordProps, IUserPasswordState> {
  state: IUserPasswordState = {
    password: '',
    visible: false,
    color: 'info',
    message: '',
    redirectLogin: false,
    showMessage: false,
    isMobile: false,
    disableButtonReg: false
  };

  componentWillMount() {
    window['is_mobile']();
    this.setState({
      isMobile: window['isMobile']
    });
  }

  componentWillUnmount() {
    this.props.reset();
  }

  componentDidUpdate(prevProps: IUserPasswordProps) {
    if (this.props !== prevProps) {
      const { userRequest } = this.props;
      if (userRequest.status === 'SUCCESS') {
        this.setState({
          showMessage: true
        });
        let timerId = setTimeout(() => {
          this.setState({
            showMessage: false,
            redirectLogin: true
          });
        }, 3000);
      } else if (userRequest.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: userRequest.message && userRequest.message !== 'ERROR' ? userRequest.message : translate('register.messages.error.fail')
        });
      } else {
        this.setState({
          disableButtonReg: false
        });
      }
    }
  }

  handleValidSubmit = (event, values) => {
    // const key = getUrlParameter('key', this.props.location.search);
    let id;
    if (this.props.location.state) {
      id = this.props.location.state.id;
    }
    //const id = this.props.match.params.id;
    let password = values.newPassword;
    if (password && password.indexOf(' ') > -1) {
      this.setState({
        visible: true,
        color: 'danger',
        message: 'Mật khẩu không được chứa khoảng trắng.'
      });
    } else {
      let key = this.props.responseSendOtp && this.props.responseSendOtp.register ? this.props.responseSendOtp.register.activationKey : '';
      this.props.savePassword(id, key, values.newPassword);
      this.setState({
        disableButtonReg: true
      });
    }
  };

  updatePassword = event => {
    this.setState({ password: event.target.value });
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    const { userRequest } = this.props;
    if (this.state.redirectLogin) {
      login(this.props.config);
    }
    return (
      <div>
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã đăng ký thành công'} />

        <Row className="justify-content-center">
          <Col className="box-password">
            <h1 className="text-center font-weight-bold" id="register-title">
              <Translate contentKey="register.title">Registration</Translate>
            </h1>
            <h3 className="text-center txtContent">
              <Translate contentKey="password.txtContent" />
            </h3>
            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
              {userRequest && userRequest.status === 'SUCCESS' ? (
                <Link to="/" className="alert-link btnSignIn">
                  <Translate contentKey="global.messages.info.authenticated.link">sign in</Translate>
                </Link>
              ) : null}
            </Alert>
            <AvForm id="password-form" onValidSubmit={this.handleValidSubmit}>
              <AvField
                name="newPassword"
                label={translate('global.form.password.label')}
                placeholder={translate('global.form.password.placeholder')}
                type="password"
                validate={{
                  required: { value: true, errorMessage: translate('global.messages.validate.newpassword.required') },
                  pattern: {
                    value: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$',
                    errorMessage: translate('global.messages.validate.newpassword.strengthmessage')
                  },
                  minLength: { value: 8, errorMessage: translate('global.messages.validate.newpassword.minlength') },
                  maxLength: { value: 30, errorMessage: translate('global.messages.validate.newpassword.maxlength') }
                }}
                onChange={this.updatePassword}
              />
              {/* <PasswordStrengthBar password={this.state.password} /> */}
              <AvField
                name="confirmPassword"
                label={translate('global.form.confirmpassword.label')}
                placeholder={translate('global.form.confirmpassword.placeholder')}
                type="password"
                validate={{
                  required: { value: true, errorMessage: translate('global.messages.validate.confirmpassword.required') },
                  minLength: { value: 8, errorMessage: translate('global.messages.validate.confirmpassword.minlength') },
                  maxLength: { value: 30, errorMessage: translate('global.messages.validate.confirmpassword.maxlength') },
                  match: {
                    value: 'newPassword',
                    errorMessage: translate('global.messages.error.dontmatch')
                  }
                }}
              />
              <Button className="btn-register" type="submit" disabled={this.state.disableButtonReg} block>
                <Translate contentKey="register.form.button">Register</Translate>
              </Button>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  isAuthenticated: storeState.authentication.isAuthenticated,
  userRequest: storeState.passwordReg.userRequest,
  createSuccess: storeState.passwordReg.createSuccess,
  createFailure: storeState.passwordReg.createFailure,
  config: storeState.applicationProfile.config,
  responseSendOtp: storeState.sendotp.response
});

const mapDispatchToProps = { getSession, savePassword, reset };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordPage);
